import { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "牛奶动漫库如何按年份检索番剧？",
    a: "在「番剧检索」页面选择目标年份即可，也可以结合评分排序与标签筛选组合使用，快速回看任意年份的口碑番剧。",
  },
  {
    q: "剧场版和 OVA 分区有什么不同？",
    a: "剧场版指在影院上映的电影作品，OVA 则通常为发售的原创或番外动画。两者都在检索页按播放形式单独划分，方便直接定位。",
  },
  {
    q: "评分是怎么来的？",
    a: "评分综合观众口碑与多平台评价沉淀而成，并用于高口碑榜单排序。评分越高，说明越经得起多数观众的认可。",
  },
  {
    q: "什么是隐藏目录？",
    a: "隐藏目录收录了不那么热门却同样精彩的冷门遗珠、OVA 番外等宝藏内容，专门为资深番友准备的彩蛋入口。",
  },
  {
    q: "能只看某个标签下的番吗？",
    a: "可以。分类导航与检索页都支持按「热血、恋爱、奇幻、悬疑」等 18 个标签单独筛选，也能多标签叠加检索。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 lg:grid-cols-12 md:px-8">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-secondary-700">
            <i className="ri-question-answer-line"></i> FAQ
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">常见问题</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-600">
            还没找到答案？进入「番剧检索」体验完整筛选，或到「关于我们」页面联系我们。
          </p>
          <Link
            to="/guanyu"
            className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            联系与帮助 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3 lg:col-span-8">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-heading text-base font-bold text-foreground-900">{f.q}</h3>
                  <i
                    className={`ri-add-line text-xl text-primary-600 transition-transform ${isOpen ? "rotate-45" : ""}`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-6 text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}